import React from 'react';
import { FileText, CreditCard, ShieldCheck, ArrowRight, Sparkles } from 'lucide-react';

const documents = [
  {
    icon: FileText,
    title: "Slip Gaji Terkini",
    subtitle: "3 Bulan Terakhir",
    description: "Bukti pendapatan bulanan anda",
    color: "emerald",
    bgGradient: "from-emerald-50 to-emerald-100",
    iconBg: "from-emerald-500 to-emerald-700",
    borderColor: "border-emerald-200"
  },
  {
    icon: ShieldCheck,
    title: "Laporan CTOS",
    subtitle: "Terkini",
    description: "Rekod kewangan & kredit anda",
    color: "amber",
    bgGradient: "from-amber-50 to-amber-100",
    iconBg: "from-amber-500 to-amber-600",
    borderColor: "border-amber-200"
  },
  {
    icon: CreditCard,
    title: "Laporan CCRIS",
    subtitle: "Terkini",
    description: "Rekod pinjaman & komitmen anda",
    color: "blue",
    bgGradient: "from-blue-50 to-blue-100",
    iconBg: "from-blue-500 to-blue-700",
    borderColor: "border-blue-200"
  }
];

const DocumentChecklist = () => {
  return (
    <section className="py-12 sm:py-16 bg-gradient-to-b from-white via-emerald-50/30 to-white relative overflow-hidden">
      {/* Decorative Background Elements */}
      <div className="absolute inset-0 opacity-5 pointer-events-none">
        <div className="absolute top-20 left-10 w-64 h-64 bg-emerald-400 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-72 h-72 bg-amber-400 rounded-full blur-3xl"></div>
      </div>

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="max-w-5xl mx-auto">
          {/* Title */}
          <div className="text-center mb-10 sm:mb-14">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-amber-100 rounded-full mb-4 border border-amber-200">
              <Sparkles className="h-4 w-4 text-amber-600" />
              <span className="text-amber-800 text-xs font-bold uppercase tracking-wider">
                Dokumen Sokongan
              </span>
            </div>
            <h2 className="text-2xl sm:text-3xl lg:text-5xl font-bold text-emerald-900 mb-4">
              Dokumen Diperlukan
            </h2>
            <p className="text-emerald-700 text-sm sm:text-base lg:text-lg max-w-2xl mx-auto">
              Hanya <span className="font-bold text-amber-600">3 dokumen mudah</span> untuk proses semakan lanjut
            </p>
          </div>

          {/* Documents Grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 sm:gap-8 mb-10">
            {documents.map((doc, index) => {
              const IconComponent = doc.icon;
              return (
                <div
                  key={index}
                  className={`group relative bg-white rounded-2xl overflow-hidden shadow-lg hover:shadow-2xl border-2 ${doc.borderColor} hover:-translate-y-2 transition-all duration-500`}
                >
                  {/* Top gradient banner */}
                  <div className={`h-2 bg-gradient-to-r ${doc.iconBg}`}></div>

                  {/* Number badge */}
                  <div className="absolute top-6 right-6 text-6xl sm:text-7xl font-bold text-emerald-100 select-none">
                    0{index + 1}
                  </div>

                  <div className="p-6 sm:p-8 relative">
                    {/* Icon */}
                    <div className={`inline-flex items-center justify-center w-16 h-16 sm:w-20 sm:h-20 bg-gradient-to-br ${doc.iconBg} rounded-2xl mb-5 shadow-xl group-hover:scale-110 group-hover:rotate-3 transition-all duration-300`}>
                      <IconComponent className="h-8 w-8 sm:h-10 sm:w-10 text-white" />
                    </div>

                    {/* Title */}
                    <h3 className="text-xl sm:text-2xl font-bold text-emerald-900 mb-1">
                      {doc.title}
                    </h3>

                    {/* Subtitle Badge */}
                    <div className={`inline-block px-3 py-1 bg-gradient-to-r ${doc.bgGradient} rounded-full mb-4`}>
                      <span className="text-xs sm:text-sm font-semibold text-emerald-800">
                        {doc.subtitle}
                      </span>
                    </div>

                    {/* Description */}
                    <p className="text-emerald-700 text-sm sm:text-base leading-relaxed">
                      {doc.description}
                    </p>
                  </div>

                  {/* Hover indicator */}
                  <div className={`absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r ${doc.iconBg} scale-x-0 group-hover:scale-x-100 transition-transform duration-500 origin-left`}></div>
                </div>
              );
            })}
          </div>

          {/* Info Banner */}
          <div className="relative bg-gradient-to-br from-emerald-900 via-emerald-800 to-emerald-950 rounded-3xl p-6 sm:p-10 overflow-hidden shadow-2xl">
            {/* Decorative pattern */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-amber-500/20 rounded-full blur-3xl"></div>
            <div className="absolute bottom-0 left-0 w-64 h-64 bg-amber-400/10 rounded-full blur-3xl"></div>

            <div className="relative z-10 flex flex-col sm:flex-row items-start sm:items-center gap-5">
              {/* Icon */}
              <div className="flex-shrink-0">
                <div className="w-16 h-16 sm:w-20 sm:h-20 bg-amber-500 rounded-2xl flex items-center justify-center shadow-xl">
                  <Sparkles className="h-8 w-8 sm:h-10 sm:w-10 text-emerald-950" />
                </div>
              </div>

              {/* Content */}
              <div className="flex-1">
                <h3 className="text-xl sm:text-2xl font-bold text-white mb-2">
                  Tak Perlu Risau!
                </h3>
                <p className="text-emerald-100 text-sm sm:text-base leading-relaxed mb-3">
                  Untuk <span className="text-amber-400 font-bold">semakan awal PERCUMA</span>, anda hanya perlu isi 3 maklumat asas.
                  Dokumen di atas hanya diperlukan selepas anda bersetuju dengan pilihan yang disarankan.
                </p>
                <div className="flex flex-wrap items-center gap-3 text-amber-300 text-sm font-semibold">
                  <ArrowRight className="h-4 w-4" />
                  <span>Ketahui kelayakan anda dalam masa 2 minit</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DocumentChecklist;
